









































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import DateMethods from '@/mixins/DateMethods.vue';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import TicketInternalNote from '@/components/Chat/Actions/TicketInternalNote.vue';
import DeleteMessageAction from '@/components/Overlays/Actions/MessageActions/DeleteMessageAction.vue';

@Component({
    components: {
        TicketInternalNote,
        DeleteMessageAction,
    },
    computed: {
        ...mapGetters({
            user: 'User/getUser',
            ticketConversation: 'UserTickets/getUserTicketConversation',
        }),
    },
})
export default class UserTicketsChat extends Mixins(
    DateMethods,
    GlobalOverlayMethods,
    InputFieldMethods,
) {
    public messageText: string = '';
    public showMessageActions: boolean = false;
    public deleteableNoteId: number = null;

    constructor() {
        super();
    }

    get userCurrentTicket() {
        return this.$store.getters['UserTickets/getUserCurrentTicket'];
    }

    public openMessageActions(noteId: number) {
        this.showMessageActions = true;
        this.deleteableNoteId   = noteId;
    }

    public closeOverlay() {
        this.showMessageActions = false;
        this.deleteableNoteId   = null;
    }

    public deleteMessage() {
        this.$store.dispatch(Actions.DELETE_TICKET_MESSAGE, {
            ticketId: this.userCurrentTicket.id,
            messageId: this.deleteableNoteId,
        }).then(() => {
            this.closeOverlay();
        });
    }

    public userSendNewMessage(conversationId: number)  {
        if (this.messageText.trim() === '') {
            return false;
        }

        this.$store.dispatch(Actions.SEND_TICKET_MESSAGE_TO_ADMIN, { conversationId, text: this.messageText });
        this.messageText = '';
        this.setInputFieldHeight(false, true);
    }

    public openNewNoteForm() {
        this.openGlobalOverlay({
            pageComponent: 'StaffCreateTicketNote',
            dialogClasses: 'hoc-global-dialog-slider',
        });
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffBackButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_HEADER_TEXT, this.$t('header.ticket-chat', 'Ticket chat'));
    }

    public created() {
        const currentTicket = this.$store.getters['UserTickets/getUserCurrentTicket'];

        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
        if (currentTicket.conversation) {
            this.$store.dispatch(Actions.FETCH_USER_TICKET_CONVERSATION, currentTicket.conversation.id);
        }
    }

    public mounted() {
        this.textInputElement = (this.$refs['message-text'] as HTMLTextAreaElement);
    }
}
